import React from 'react';
import { Box } from '@mui/material';

import WidgetFrame from './WidgetFrame';
import { sizeHeightPx, sizeWidthPx } from './sizes';

/**
 * Gallery miniature: the real widget rendered at its desktop size and CSS-scaled into the
 * card. Never fetches (locked widgets must not call gated endpoints; the rest reuse the cache).
 */
export default function WidgetPreview({ entry, size, locked, width = 236, height = 120 }) {
  const fullWidth = sizeWidthPx(size);
  const fullHeight = sizeHeightPx(size);
  const scale = Math.min(width / fullWidth, height / fullHeight);
  return (
    <Box sx={{ width, height, overflow: 'hidden', borderRadius: '8px', bgcolor: '#f8fafc', position: 'relative', filter: locked ? 'grayscale(1)' : 'none', opacity: locked ? 0.55 : 1 }}>
      <Box sx={{ position: 'absolute', left: '50%', top: '50%', width: fullWidth, height: fullHeight, transform: `translate(-50%, -50%) scale(${scale})`, transformOrigin: 'center', pointerEvents: 'none' }}>
        <WidgetFrame entry={entry} id={entry.id} size={size} opts={entry.defaultOpts || {}} mode="view" inPreview locked={false} />
      </Box>
    </Box>
  );
}
